export const CvAnonymeStyle = {

    cvpagepreview : {
        'page-break-after': 'always',
        display: 'flex',
        gap:'16px',
        flexDirection: 'column',
        width: '800px',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
    },

    logo: {
        display: 'flex',
        width: '146.83px',
        //paddingLeft: '20px',
        //paddingTop: '20px',
        //height: '40px',
        //flex: 'none',
        //order: '0',
        //flexGrow: '0',

    },

    allcvcontent : {
        // display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        justifyContent:'space-between',
        //paddingTop:'30px',
        //paddingLeft:'20px',
        gap:'8px',
        display:'flex',
        width:'800px',

        /* Inside auto layout */

        //flex:'none',
        //order:'1',
        //flexGrow:'0',
    },

    cvpreview : {
        //marginLeft: '75px',
        //marginTop: '40px',
        backgroundColor: 'white',
        //padding: '30px',
    },

    styleTitre : {
        //backgroundColor: '#e1e7f0',
        color: '#0000FF',
        fontFamily: 'Lato',
        alignSelf:'stretch',
        //hieght: '20px',
        //width: '90%',
        //margin: '10px',
        //marginLeft : '-7px',
        //marginTop: '50px'
    },

    subtitleStyle : {
        color: 'blue',
        margin:0,
        fontFamily:'Lato',
        //marginLeft : '45px'

    },

    divuplogo : {
        // width: '744px',
        // padding: '20px',
        // paddingLeft: '60px',
        display: 'flex',
        gap:'4px',
        flexDirection: 'row',
        width: '800px',
        alignItems: 'flex-start',
        justifyContent: 'space-between'

    },

    titleposte : {
        textAlign: 'center',
        marginTop: '25px',
        //marginBottom: '-25px',
        color : '#066FA0',
        alignSelf:'stretch',
        fontWeight : 'bold'
    },

    competences : {
        backgroundColor: '#cfd3d55c',
        color: 'black',
        width: '100%',
        //margin: '10px 10px 10px 33px',
        fontWeight: 'bold',
        //marginTop: '-34px',
    },

    tabstyle : {
        width: '700px',
        //marginTop: '-15px',
        //marginLeft: '60px'
    },

    columnstyle : {
        width: '428px',
        color:'#5B8AC1'
    },

    synthtxtcolor : {
        color : 'black'
    }
};